(function() {
  'use strict';

  // Sécurité « zéro euro » : sur la page /cart, supprime automatiquement
  // tout item ayant le tag produit-sur-mesure ET un price=0. Affiche un
  // toast d'alerte au reload pour informer le client (titres + raison).
  // Le drawer cart n'est pas touché — uniquement /cart parce que c'est
  // la page de validation finale avant checkout.

  var TOAST_KEY = 'mooZeroGuardToast';

  // Affiche le toast s'il y a un message en sessionStorage (au reload après
  // suppression). Doit être appelé même si on n'est pas sur /cart, car
  // l'utilisateur pourrait avoir été redirigé ailleurs entre temps.
  function consumeToast() {
    var raw = null;
    try { raw = sessionStorage.getItem(TOAST_KEY); } catch(e) {}
    if (!raw) return;
    try { sessionStorage.removeItem(TOAST_KEY); } catch(e) {}
    var data;
    try { data = JSON.parse(raw); } catch(e) { return; }
    if (!data || !data.titles || !data.titles.length) return;
    showToast(data.titles);
  }

  function showToast(titles) {
    if (document.getElementById('mooZeroGuardToast')) return;
    var n = titles.length;
    var titlesText = titles.length > 3
      ? titles.slice(0, 3).map(esc).join(', ') + ' et ' + (titles.length - 3) + ' autre' + (titles.length - 3 > 1 ? 's' : '')
      : titles.map(esc).join(', ');

    var st = document.createElement('style');
    st.textContent = ''
      + '@keyframes mooZeroSlideIn{from{opacity:0;transform:translate(-50%,-12px)}to{opacity:1;transform:translate(-50%,0)}}'
      + '@keyframes mooZeroFadeOut{to{opacity:0;transform:translate(-50%,-12px)}}';
    document.head.appendChild(st);

    var toast = document.createElement('div');
    toast.id = 'mooZeroGuardToast';
    toast.style.cssText = ''
      + 'position:fixed;top:20px;left:50%;transform:translateX(-50%);'
      + 'z-index:99999;background:#fff8ed;border:1.5px solid #12312b;'
      + 'border-radius:14px;box-shadow:5px 5px 0 0 #C4622A;'
      + 'padding:14px 18px;max-width:90vw;width:520px;'
      + 'font-family:Inter,-apple-system,system-ui,sans-serif;color:#12312b;'
      + 'animation:mooZeroSlideIn .35s ease-out;';
    toast.innerHTML = ''
      + '<div style="display:flex;align-items:flex-start;gap:12px;">'
      +   '<div style="font-size:22px;line-height:1.1;flex-shrink:0;">⚠️</div>'
      +   '<div style="flex:1;min-width:0;font-size:14px;line-height:1.45;">'
      +     '<div style="font-weight:700;margin-bottom:3px;">'
      +       n + ' produit' + (n > 1 ? 's' : '') + ' retiré' + (n > 1 ? 's' : '') + ' du panier'
      +     '</div>'
      +     '<div style="font-size:13px;color:#6f7f7b;">'
      +       'Prix manquant sur : <strong style="color:#12312b;">' + titlesText + '</strong>. '
      +       'Reconfigure-le' + (n > 1 ? 's' : '') + ' depuis le configurateur ou la page produit pour l\'ajouter à nouveau.'
      +     '</div>'
      +   '</div>'
      +   '<button id="mooZeroToastClose" aria-label="Fermer" style="background:none;border:0;font-size:20px;color:#12312b;cursor:pointer;padding:0 4px;line-height:1;flex-shrink:0;font-family:inherit;">×</button>'
      + '</div>';
    document.body.appendChild(toast);

    var closeBtn = document.getElementById('mooZeroToastClose');
    if (closeBtn) closeBtn.addEventListener('click', function() {
      toast.style.animation = 'mooZeroFadeOut .3s ease-out forwards';
      setTimeout(function() { if (toast.parentNode) toast.remove(); }, 320);
    });

    // Auto-fermeture après 10 secondes (laisse largement le temps de lire)
    setTimeout(function() {
      if (!toast.parentNode) return;
      toast.style.animation = 'mooZeroFadeOut .4s ease-out forwards';
      setTimeout(function() { if (toast.parentNode) toast.remove(); }, 420);
    }, 10000);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Cache pour ne pas refetcher le même handle plusieurs fois
  var _tagCache = {};
  function isSurMesureTag(handle) {
    if (typeof _tagCache[handle] !== 'undefined') {
      return Promise.resolve(_tagCache[handle]);
    }
    return fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(p) {
        var has = (p.tags || []).some(function(t) {
          return t.toLowerCase().trim() === 'produit-sur-mesure';
        });
        _tagCache[handle] = has;
        return has;
      })
      .catch(function() { _tagCache[handle] = false; return false; });
  }

  function runZeroGuard() {
    // Évite de relancer si déjà fait dans cette navigation (anti-boucle reload)
    if (window._mooZeroGuardRan) return;
    window._mooZeroGuardRan = true;

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var zeroItems = (cart.items || []).filter(function(it) {
          return it.price === 0 || it.final_price === 0;
        });
        if (!zeroItems.length) return null;

        // Pour chaque item à 0€, vérifier le tag
        return Promise.all(zeroItems.map(function(it) {
          return isSurMesureTag(it.handle).then(function(isSm) {
            return isSm ? it : null;
          });
        })).then(function(arr) {
          return arr.filter(function(x) { return x !== null; });
        });
      })
      .then(function(toRemove) {
        if (!toRemove || !toRemove.length) return;

        // Suppression séquentielle pour éviter les race conditions Shopify
        // (Shopify recalcule le panier après chaque /cart/change)
        var titles = toRemove.map(function(it) { return it.product_title || it.title || 'Produit'; });
        var chain = Promise.resolve();
        toRemove.forEach(function(it) {
          chain = chain.then(function() {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: it.key, quantity: 0 })
            }).catch(function(e) {
              console.warn('moo-zero-guard: échec suppression', it.key, e);
            });
          });
        });
        return chain.then(function() {
          // Stocker les titres pour les afficher après reload
          try {
            sessionStorage.setItem(TOAST_KEY, JSON.stringify({
              titles: titles,
              ts: Date.now()
            }));
          } catch(e) {}
          // Petit délai pour laisser Shopify enregistrer la dernière suppression
          setTimeout(function() { window.location.reload(); }, 150);
        });
      })
      .catch(function(e) {
        console.error('moo-zero-guard error:', e);
      });
  }

  function init() {
    // Toujours essayer d'afficher le toast (l'utilisateur peut être sur n'importe
    // quelle page après le reload, on veut pas perdre l'info)
    consumeToast();
    // La garde elle-même ne tourne que sur /cart
    if (window.location.pathname === '/cart') {
      runZeroGuard();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();